import { Injectable } from '@angular/core';
import { AppConfig } from '../models/config/app-config';
import { DateFormatter } from './date-utils.service';
import { KurzfristigerAufenthaltMarshaller } from './kurzfristiger-aufenthalt-marshaller';
import { LangfristigerAufenthaltMarshaller } from './langfristiger-aufenthalt-marshaller';
import { Marshaller } from './marshaller';
import { ValueListsService } from './value-lists.service';

@Injectable()
export class MarshallerFactory {

  public createMarshaller(valueListsService: ValueListsService, dateFormatter: DateFormatter, appConfig: AppConfig): Marshaller | undefined {
    if (appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT') {
      // console.log('using KurzfristigerAufenthaltMarshaller');
      return new KurzfristigerAufenthaltMarshaller(valueListsService, dateFormatter, appConfig);
    }
    if (appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT') {
      // console.log('using LangfristigerAufenthaltMarshaller');
      return new LangfristigerAufenthaltMarshaller(valueListsService, dateFormatter, appConfig);
    }
    else {
      console.error('Unbekannter Antragsart ', appConfig.visumAntragsartEnum);
      return undefined;
    }
  }

}
